import React from 'react';
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Contact from "../components/Contact";
import ContactInfo from "../components/ContactInfo";
import FeaturesRow from "../components/FeaturesRow";
import ProcessTimeline from "../components/ProcessTimeline";
import Testimonials from "../components/Testimonials";
import VideoTestimonials from "../components/VideoTestimonials";
import Footer from "../components/Footer";
import WhatsAppButton from '../components/WhatsAppButton';

const ContactPage = () => {
    return (
        <div className="main-wrapper relative min-h-screen">
            <Navbar />
            <Hero
                badge="Contact Us"
                title={<>Get In Touch  <br /> <span className="text-[#F2B135]">With Our Team </span> </>}
                subtitle="Ready to transform your ideas into reality? Fill out the form below or reach out to us directly through our channels."
                image="/contact.jpeg"

                // Buttons
                primaryBtnText="Start Your Project"
                primaryBtnLink="/contact"
                secondaryBtnText="See Our Portfolio"
                secondaryBtnLink="/portfolio"

                // Cards data
                rating="4.9/5"
                clientCount="49+ Worldwide"
            />


            <main className="relative z-10 w-full">
                <ContactInfo />
                <Contact />
                <FeaturesRow />
                <ProcessTimeline />
                <VideoTestimonials />
                <Testimonials />
                <Footer />
                <WhatsAppButton />
            </main>
        </div>
    );
};

export default ContactPage;